import { render, staticRenderFns } from "./SettingEvaluation.vue?vue&type=template&id=03ed1470&"
import script from "./SettingEvaluation.vue?vue&type=script&lang=js&"
export * from "./SettingEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports